<template>
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1451_9863)">
      <path
        d="M7.36109 1.12512C7.48997 1.25404 7.56238 1.42888 7.56238 1.61118C7.56238 1.79348 7.48997 1.96832 7.36109 2.09724L3.95796 5.50037L7.36109 8.90349C7.48632 9.03316 7.55562 9.20682 7.55405 9.38708C7.55249 9.56734 7.48018 9.73978 7.35271 9.86724C7.22525 9.99471 7.05281 10.067 6.87255 10.0686C6.69229 10.0701 6.51863 10.0009 6.38896 9.87562L2.49978 5.98643C2.37089 5.85751 2.29848 5.68267 2.29848 5.50037C2.29848 5.31807 2.37089 5.14323 2.49978 5.01431L6.38896 1.12512C6.51789 0.996233 6.69272 0.923828 6.87502 0.923828C7.05733 0.923828 7.23216 0.996233 7.36109 1.12512Z"
        class="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_1451_9863">
        <rect
          width="11"
          height="11"
          fill="white"
          transform="matrix(-1 8.74228e-08 8.74228e-08 1 11 0)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
svg .fill {
  fill: #545454;
}

.text-white svg .fill {
  fill: #ffffff;
}
</style>
